import React from "react";
import "../Dashboard/Dashboard.css";
import { Link } from "react-router-dom";
// import { AiOutlineCalendar } from "react-icons/ai";
import { Button, } from "rsuite";
import { useTranslation } from 'react-i18next';
import { useState, useEffect, lazy, Suspense } from "react";
import axios from "axios";
import 'chart.js/auto';
import { connect } from "react-redux";
import MessageLabel from "../../components/CommonComponents/MessageLabel";
import { FiUpload, FiSettings, FiCheckCircle, FiClock, FiEye, FiExternalLink } from "react-icons/fi";
import { LuCrown } from "react-icons/lu";
import MessageHeading from "../../components/CommonComponents/MessageHeading";
import MessageSubHeading from "../../components/CommonComponents/MessageSubHeading";
import { FiHelpCircle } from "react-icons/fi";

const Line = lazy(() => import('react-chartjs-2').then(module => ({ default: module.Line })));
const Bar = lazy(() => import('react-chartjs-2').then(module => ({ default: module.Bar })));
const Pie = lazy(() => import('react-chartjs-2').then(module => ({ default: module.Pie })));
const Chart = lazy(() => import("react-apexcharts"));

function Dashboard_Partner({ onlyPermission }) {
  const { t } = useTranslation();
  const [banner, setBanner] = useState()
  // Retrieve and format the username
  let username = localStorage.getItem("username");
  if (username) {
    username = username.charAt(0).toUpperCase() + username.slice(1);
  }

  const [dashboard, setDashboard] = useState({});
  const [customerSummary, setCustomerSummary] = useState({});
  const SalesTable = ({ title, data }) => (
    <>
      <div>
        <h6 className="mb-0 text-uppercase fw-semibold">
          {title}
        </h6>
      </div>
      <div className="card shadow-sm border-0 rounded-4 overflow-hidden bg-light bg-opacity-75 mb-4">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-borderless table-hover align-middle mb-0">
              <thead className="text-secondary small text-uppercase bg-light">
                <tr>
                  <th>Date</th>
                  <th>Source</th>
                  <th>Source ID</th>
                  <th>Title</th>
                  <th className="text-end">Amount (₹)</th>
                  <th className="text-end">Total (₹)</th>
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? (
                  data.map((item, index) => (
                    <tr key={index} className="border-bottom">
                      <td>{item.date}</td>
                      <td>{item.source}</td>
                      <td>{item.source_id}</td>
                      <td className="text-muted">{item.title || "N/A"}</td>
                      <td className="text-end">
                        <span className="badge bg-success">₹{item.amount}</span>
                      </td>
                      <td className="text-end fw-semibold">₹{item.total}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-3 text-muted">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
  const getCurrentWeekData = (data) => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1));
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    return data
      .filter((item) => {
        const itemDate = new Date(item.date);
        return itemDate >= startOfWeek && itemDate <= endOfWeek;
      })
      .map((item) => ({
        x: new Date(item.date).getTime(),
        y: item.count,
      }));
  };



  function HelpdeskFloatingButton() {
    const [showTooltip, setShowTooltip] = useState(false);

    return (
      <div
        className="position-fixed"
        style={{ bottom: "60px", right: "5px", zIndex: 1050 }}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <Link
          to="https://helpdesk.flicknexs.com"
          className="d-flex align-items-center justify-content-center bg-primary-subtle text-primary rounded-circle"
          style={{ width: 48, height: 48 }}
        >
          <FiHelpCircle size={24} />
        </Link>

        {showTooltip && (
          <div
            style={{
              position: "absolute",
              bottom: "60px",
              right: 0,
              background: "#fff",
              padding: "16px",
              border: "1px solid #dee2e6",
              borderRadius: "12px",
              width: "280px",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
              color: "#333",
            }}
          >
            <h6 className="mb-1 fw-bold text-dark">
              {t(`Need Help?`)}
            </h6>
            <p className="mb-2 small text-muted">
              {t(`  Our support team is here to assist you with setup, features, and issues.`)}
            </p>
            <Link


              to="https://helpdesk.flicknexs.com"
              className="text-decoration-none text-primary fw-semibold small"
            >
              Go to Helpdesk →
            </Link>
          </div>
        )}
      </div>
    );
  }

  const weeklyRegisteredUsersSeries = [
    {
      name: "Weekly Registered Users",
      data: getCurrentWeekData(customerSummary.weekSummaryregisteredUsersGraph ?? []),
    },
  ];

  const weeklySubscriberUsersSeries = [
    {
      name: "Weekly Subscriber Users",
      data: getCurrentWeekData(customerSummary.weekSummarysubscriberUsersGraph ?? []),
    },
  ];

  const [isMonthlyOpen, setIsMonthlyOpen] = useState(false);
  const [isSalesOpen, setIsSalesOpen] = useState(false);
  const options = {
    chart: {
      type: "line",
      zoom: { enabled: true },
    },
    xaxis: {
      type: "datetime",
      title: { text: "Date" },
    },
    yaxis: {
      title: { text: "User Count" },
    },
    stroke: {
      curve: "smooth",
    },
    tooltip: {
      x: { format: "ddd, MMM d" },
    },
  };

  const monthlyRegisteredUsersData = {
    labels: (customerSummary.monthSummaryRegisteredUsersGraph ?? []).map((data) => data.month),
    datasets: [
      {
        label: "Registered Users",
        data: (customerSummary.monthSummaryRegisteredUsersGraph ?? []).map((data) => data.count),
        backgroundColor: "rgba(79, 70, 229, 0.6)",
      },
    ],
  };

  const monthlySubscriberUsersData = {
    labels: (customerSummary.monthSummarySubscriberUsersGraph ?? []).map((data) => data.month),
    datasets: [
      {
        label: "Subscriber Users",
        data: (customerSummary.monthSummarySubscriberUsersGraph ?? []).map((data) => data.count),
        backgroundColor: "rgb(35, 146, 109)",
      },
    ],
  };

  const MonthlySummaryTable = ({ title, data }) => (
    <>
      <div>
        <h6 className="mb-0 text-uppercase fw-semibold">
          {title}
        </h6>
      </div>
      <div className="card shadow-sm border-0 rounded-4 overflow-hidden bg-light bg-opacity-75 mb-4">

        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-borderless table-hover align-middle mb-0">
              <thead className="text-secondary small text-uppercase bg-light">
                <tr>
                  <th>Date</th>
                  <th>Units Sold</th>
                  <th>Total Amount</th>
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? (
                  data.map((item, index) => (
                    <tr key={index} className="border-bottom">
                      <td>{item.date}</td>
                      <td>{item.unitsSold}</td>
                      <td className="fw-semibold">
                        {item.totalAmount}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center py-3 text-muted">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );

  const salesSummaryData = [
    { title: "Last Month", data: dashboard?.lastMonthData },
    { title: "Current Month", data: dashboard?.currentMonthData },
    { title: "Last Week", data: dashboard?.lastWeekData },
    { title: "Last Day", data: dashboard?.lastDayData },
    { title: "Today", data: dashboard?.todayData },
  ];

  const monthlySummaryData = [
    { title: "Last Month", data: dashboard?.lastMonthDeductionsData },
    { title: "Current Month", data: dashboard?.currentMonthDeductionsData },
    { title: "Last Week", data: dashboard?.lastWeekDeductionsData },
    { title: "Last Day", data: dashboard?.lastDayDeductionsData },
    { title: "Today", data: dashboard?.todayDeductionsData },
  ];

  const [combinedChartSeries, setCombinedChartSeries] = useState([
    { name: "No Data", data: [] }
  ]);

  const [combinedChartOptions, setCombinedChartOptions] = useState({
    chart: {
      type: "line",
      height: 400,
    },
    xaxis: {
      categories: [],
    },
  });

  useEffect(() => {
    if (!dashboard) return;

    const processMonthlyData = (dataArray, valueKey) => {
      const dataByMonth = {};
      dataArray.forEach((item) => {
        const date = new Date(item.createdAt);
        const monthKey = date.toLocaleString("default", { month: "short", year: "numeric" });
        dataByMonth[monthKey] = (dataByMonth[monthKey] || 0) + item[valueKey];
      });

      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth();
      const allMonths = Array.from({ length: currentMonth + 1 }, (_, i) => {
        const date = new Date(currentYear, i);
        return date.toLocaleString("default", { month: "short", year: "numeric" });
      });

      const values = allMonths.map((month) => dataByMonth[month] || 0);
      return { labels: allMonths, data: values };
    };

    const purchases = dashboard.Number_of_purchases_contents?.length
      ? processMonthlyData(dashboard.Number_of_purchases_contents, "purchase_count")
      : null;

    const earnings = dashboard.Number_of_earnings_on_contents?.length
      ? processMonthlyData(dashboard.Number_of_earnings_on_contents, "total_earnings")
      : null;

    const subscriptionCount = dashboard.Number_of_subscription_on_count?.length
      ? processMonthlyData(dashboard.Number_of_subscription_on_count, "subscription_count")
      : null;

    const subscriptionEarnings = dashboard.Number_of_subscription_earnings?.length
      ? processMonthlyData(dashboard.Number_of_subscription_earnings, "total_earnings")
      : null;

    const hasData = purchases || earnings || subscriptionCount || subscriptionEarnings;

    if (!hasData) {
      setCombinedChartSeries([
        { name: "No Data", data: [] }
      ]);
      return;
    }

    const combinedLabels = purchases?.labels || earnings?.labels || subscriptionCount?.labels || subscriptionEarnings?.labels;

    const series = [
      {
        name: "PPV Purchases",
        type: "column",
        data: purchases?.data || [],
        yAxisIndex: 0,
      },
      {
        name: "Subscriptions",
        type: "column",
        data: subscriptionCount?.data || [],
        yAxisIndex: 0,
      },
      {
        name: "PPV Earnings",
        type: "line",
        data: earnings?.data || [],
        yAxisIndex: 1,
      },
      {
        name: "Subscription Earnings",
        type: "line",
        data: subscriptionEarnings?.data || [],
        yAxisIndex: 1,
      },
    ];



    const strokeWidths = series.map((s) => (s.type === "line" || s.type === "area" ? 3 : 0));

    setCombinedChartOptions({
      chart: {
        type: "line",
        height: 400,
        toolbar: { show: false },
        zoom: { enabled: false },
        fontFamily: "Inter, sans-serif",
        stacked: false,
      },
      noData: {
        text: "No data available",
        align: 'center',
        verticalAlign: 'middle',
        style: {
          color: '#999',
          fontSize: '16px',
        },
      },
      stroke: {
        width: [0, 0, 3, 3],
        curve: "smooth",
        dashArray: [0, 0, 0, 6],
      },
      plotOptions: {
        bar: {
          columnWidth: "45%",
          borderRadius: 6,
        },
      },
      dataLabels: { enabled: false },
      xaxis: {
        categories: combinedLabels,
        labels: {
          rotate: -45,
          style: { fontSize: "13px", color: "#1e3a8a" },
        },
        axisBorder: { show: false },
        axisTicks: { show: false },
      },
      yaxis: [
        {
          title: { text: "Count", style: { fontSize: "13px", color: "#1e3a8a" } },
          labels: {
            formatter: (val) => Math.round(val || 0),
            style: { fontSize: "12px", color: "#1e3a8a" },
          },
          min: 0,
        },
        {
          opposite: true,
          title: { text: "Earnings", style: { fontSize: "13px", color: "#1e3a8a" } },
          labels: {
            formatter: (val) => Math.round(val || 0),
            style: { fontSize: "12px", color: "#1e3a8a" },
          },
          min: 0,
        },
      ],
      tooltip: {
        shared: true,
        intersect: false,
        theme: "light",
        x: {
          formatter: (val, opts) => combinedLabels[opts.dataPointIndex] || val,
        },
        y: {
          formatter: (val) => Math.round(val || 0),
        },
      },
      colors: [
        "#9ED4FD", // PPV Purchases
        "#64A7D1", // Subscriptions
        "#3B82F6", // PPV Earnings
        "#1D4ED8"  // Subscription Earnings (sharper blue)
      ],
      fill: {
        type: ["solid", "solid", "solid", "solid"], // remove gradient
        gradient: {
          shade: "light",
          type: "vertical",
          shadeIntensity: 0.25,
          opacityFrom: 0.6,
          opacityTo: 0.05,
          stops: [0, 90, 100],
        },
        opacity: [1, 1, 1, 1],
      },
      legend: {
        position: "top",
        horizontalAlign: "right",
        labels: { colors: "#1e3a8a" },
        itemMargin: { horizontal: 10 },
      },
      grid: {
        borderColor: "#e0f2fe",
        strokeDashArray: 3,
      },
    });


    setCombinedChartSeries(series);
  }, [dashboard]);

  const access_token = localStorage.getItem("access_token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${access_token}`,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const endpoints = [
          axios.get(`${process.env.REACT_APP_Baseurl}/admin/dashboard`, { headers }),
          axios.get(`${process.env.REACT_APP_Baseurl}/admin/customer-summary-dashboard`, { headers }),
          axios.get(`${process.env.REACT_APP_Base_Webnexs_URL}/view_banner/e4e1hzm8fkz3pa`)
        ];

        const [dashboardRes, customerRes, bannerRes] = await Promise.allSettled(endpoints);

        if (dashboardRes.status === 'fulfilled') {
          setDashboard(dashboardRes.value.data.data || {});
        }
        if (customerRes.status === 'fulfilled') {
          setCustomerSummary(customerRes.value.data || {});
        }
        if (bannerRes.status === 'fulfilled') {
          const result = bannerRes.value?.data?.banners?.[0]?.banner_image;
          if (result) setBanner(result);
        }
      } catch (error) {
        console.error("Dashboard Data Fetch Error:", error);
      }
    };

    if (onlyPermission?.includes(1)) {
      fetchDashboardData();
    }
  }, [onlyPermission]);

  const donutData = {
    "Videos": dashboard?.current_videos_count || 0,
    "Livestream": dashboard?.current_livestream_count || 0,
    "Audios": dashboard?.current_audios_count || 0,
    "Series": dashboard?.current_series_count || 0,
  };

  const donutseries = Object.values(donutData);
  const donutlabels = Object.keys(donutData);

  const donutoptions = {
    chart: {
      type: 'donut',
    },
    labels: donutlabels,
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 300,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
    legend: {
      position: 'right',
    },
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        if (opts?.w?.globals?.series && opts.seriesIndex !== undefined) {
          return opts.w.globals.series[opts.seriesIndex];
        }
        return val;
      },
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              show: true,
            },
            value: {
              show: true,
              formatter: function (val, opts) {
                if (opts?.w?.globals?.series && opts.seriesIndex !== undefined) {
                  return opts.w.globals.series[opts.seriesIndex];
                }
                return val;
              },
            },
            total: {
              show: true,
              label: 'Total',
              formatter: function (w) {
                if (w?.globals?.seriesTotals) {
                  return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                }
                return '';
              },
            },
          },
        },
      },
    },
    colors: ['#0A579E', '#1578CF', '#249CFF', '#77C2FE', '#0d47a1']
  };

  const registeredData = customerSummary?.monthSummaryRegisteredUsersGraph ?? [];
  const subscribedData = customerSummary?.monthSummarySubscriberUsersGraph ?? [];

  const months = registeredData.map(item => item?.month ?? '');
  const registeredCounts = registeredData.map(item => item?.count ?? 0);
  const subscribedCounts = subscribedData.map(item => item?.count ?? 0);
  const hasData = months.length > 0;
  const combinedUsersSeries = [
    {
      name: "Registered Users",
      type: "line",
      data: registeredCounts
    },
    {
      name: "Subscribed Users",
      type: "area",
      data: subscribedCounts
    }
  ];

  const combinedUsersOptions = {
    chart: {
      type: 'line',
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false
        }
      }
    },
    stroke: {
      curve: 'smooth',
      width: [2, 2]
    },
    fill: {
      type: ['solid', 'gradient'],
      gradient: {
        shadeIntensity: 0.7,
        opacityFrom: 0.4,
        opacityTo: 0.05,
        stops: [0, 90, 100]
      }
    },
    tooltip: {
      enabled: true,
      theme: "dark",
      shared: true,
      intersect: false,
      x: {
        show: true,
        formatter: (val, opts) => {
          return months[opts.dataPointIndex] || '';
        }
      },
      y: {
        formatter: (val, { seriesIndex }) => {
          const wholeNumber = Math.floor(val);
          return seriesIndex === 0 ? `${wholeNumber} registered` : `${wholeNumber} subscribers`;
        }
      }
    },
    // markers: {
    //   size: [3, 0]
    // },
    markers: {
      size: [0, 0, 0, 5],
      colors: "#1D4ED8",
      strokeColors: "#1D4ED8",
      strokeWidth: 2,
      hover: {
        size: 6,
      },
    },

    colors: ['#2196f3', '#0A579E'],
    xaxis: {
      categories: months,
      labels: {
        style: {
          colors: '#999'
        }
      }
    },
    yaxis: [
      {
        title: {
          text: 'Registered Users',
          style: {
            color: '#2196f3'
          }
        },
        labels: {
          style: {
            colors: '#2196f3'
          },
          formatter: (val) => {
            return Math.floor(val).toString();
          }
        }
      },
      {
        opposite: true,
        title: {
          text: 'Subscribed Users',
          style: {
            color: '#0A579E'
          }
        },
        labels: {
          style: {
            colors: '#0A579E'
          },
          formatter: (val) => {
            return Math.floor(val).toString();
          }
        }
      }
    ],
    legend: {
      show: true,
      position: 'top',
      horizontalAlign: 'center',
      labels: {
        colors: '#999'
      }
    },
    grid: {
      borderColor: '#e0e0e0',
      strokeDashArray: 3
    }
  };

  return (
    <>
      <section>
        <div className=" m-0 p-0">
          <div className="container-fluid">
            <div className="p-3">
              <h3 className="mb-2">{t(`Good day, ${username}!`)}</h3>
              <MessageSubHeading text={"Explore your streaming insights and see how your audience is engaging with your content."} className="text-muted flex-grow-1" />
            </div>
            {onlyPermission?.includes(1) ? <>
              <div className="theme-bg-color rounded-5 p-4 my-3">
                <div className="row align-items-center mb-4">
                  <div className="col-md-6">
                    <MessageHeading text={"Get Started"} classname="theme-text-color" noMargin border />
                    <MessageSubHeading text={"You're just steps away from completing your setup!"} className="text-muted flex-grow-1" />
                  </div>
                  <div className="col-md-6 text-md-end mt-3 mt-md-0 d-flex justify-content-md-end flex-wrap gap-2">
                    {dashboard?.user_details?.package && (
                      <div className="d-inline-flex align-items-center bg-success-subtle text-success px-3 py-2 rounded-pill shadow-sm">
                        <FiCheckCircle className="me-2" />
                        <span className="fw-semibold small">
                          {t(`Subscribed to ${dashboard?.user_details?.package}`)}
                        </span>
                      </div>
                    )}
                    {dashboard?.user_details?.package_ends && (
                      <div className="d-inline-flex align-items-center bg-warning-subtle text-dark px-3 py-2 rounded-pill shadow-sm">
                        <FiClock className="me-2" />
                        <span className="fw-semibold small">
                          {t(`Ends on -  ${dashboard?.user_details?.package_ends}`)}
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="row g-4">
                  {[
                    {
                      title: "Upload Your Content",
                      description: t("Add at least one video to get started."),
                      link: "/add-library",
                      linkText: t("Upload Now"),
                      Icon: FiUpload,
                    },
                    // {
                    //   title: "Customize Your Store",
                    //   description: t("Logo, Name, Social Links, Payment Types, and more."),
                    //   link: "/settings",
                    //   linkText: t("Go to Storefront Settings"),
                    //   Icon: FiSettings,
                    // },
                    // {
                    //   title: "Add Subscription Plans",
                    //   description: t("Create pricing plans for your audience."),
                    //   link: "/subscription-plans",
                    //   linkText: t("Add Plans"),
                    //   Icon: LuCrown,
                    // },
                  ].map((step, idx) => (
                    <div className="col-md-4" key={idx}>
                      <div className="card border-0 theme-bg-color shadow-sm h-100">
                        <div className="card-body d-flex flex-column">
                          <div
                            className={`rounded-circle d-inline-flex justify-content-center align-items-center mb-3 ${step.bg}`}
                            style={{ width: 50, height: 50 }}
                          >
                            <step.Icon className="fs-5" />
                          </div>
                          <MessageLabel text={step.title} classname="theme-text-color" noMargin />
                          <MessageSubHeading text={step.description} className="text-muted mb-2 flex-grow-1" />
                          <Link to={step.link} className="live-button button-bg-color text-center py-2 px-3">
                            {step.linkText}
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* {banner && (
                <div className="mt-5 mb-5">
                  <Link to="https://wcart.io/create-store" target="_blank" rel="noopener noreferrer">
                    <img src={banner} className="d-block w-100" alt="banner" />
                  </Link>
                </div>
              )} */}

              {/* <div className="row mt-2 d-flex">
                <div className="col-lg-6 d-flex">
                  <div className="rounded-5 theme-bg-color p-4 mt-4 w-100 d-flex flex-column justify-content-between">
                    <MessageHeading border text={`Content's of ${username}!`} className="mb-3 text-center" />
                    <Chart options={donutoptions} series={donutseries} type="donut" width="100%" height={270} />
                  </div>
                </div>

                <div className="col-lg-6 d-flex">
                  <div className="rounded-5 theme-bg-color p-4 mt-4 w-100 d-flex flex-column justify-content-between position-relative">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <MessageHeading border text={"Users Overview"} noMargin padding />
                      <Link to="/analytics/users" >
                        <FiExternalLink size={18} style={{ color: "#1578CF" }} />
                      </Link>
                    </div>

                    {hasData ? (
                      <Chart
                        options={combinedUsersOptions}
                        series={combinedUsersSeries}
                        type="line"
                        height={250}
                      />
                    ) : (
                      <div className="text-center py-4 flex-grow-1 d-flex align-items-center justify-content-center">
                        <p className="text-muted">{t("No data available")}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>


              <div className="col-lg-12 col-md-12 pt-3">
                <div className="rounded-5 theme-bg-color p-4 mt-4">
                  <div className="chart-container">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <MessageHeading text={"Payment Performance Overview"} className="text-muted mb-0" border noMargin padding />

                      <div className="d-flex gap-3 align-items-center">
                        <div className="d-flex align-items-center gap-1">
                          <MessageSubHeading text={"PPV Analytics:"} className="text-muted" noMargin />
                          <Link to="/analytics/ppv" >
                            <FiExternalLink size={18} style={{ color: "#1578CF" }} />
                          </Link>
                        </div>
                        <div className="d-flex align-items-center gap-1">
                          <MessageSubHeading text={"Subscriber Analytics:"} className="text-muted" noMargin />
                          <Link to="/analytics/subscriber">
                            <FiExternalLink size={18} style={{ color: "#1578CF" }} />
                          </Link>
                        </div>
                      </div>
                    </div>
                    <Chart
                      options={combinedChartOptions}
                      series={combinedChartSeries}
                      type="line"
                      height={400}
                    />
                  </div>
                </div>
              </div> */}

            </> : ""}
          </div>
        </div>
      </section>
      <HelpdeskFloatingButton />
    </>
  );
}
const mapStateToProps = state => ({
  onlyPermission: state.userPermission.onlyPermission,
});

export default connect(mapStateToProps)(Dashboard_Partner);
